import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../main.css';
import HHlogo from '../HHlogo.png';

function PrimaryNav() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/high-school/contact');
  };

  return (
    <Navbar expand="lg" expanded={expanded} className="custom-navbar">
      <Container>
        <Navbar.Brand as={Link} to="/primary-school" className="d-flex align-items-center">
          <img
            src={HHlogo}
            alt="HHLogo"
            className="navbar-logo d-inline-block align-top me-2"
            style={{ cursor: 'pointer', height: '40px' }}
          />
          HIGHLANDS
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
          className={`custom-toggler ${expanded ? 'open' : ''}`}
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
 <Nav className="me-auto">
  <Nav.Link as={Link} to="/">HOME</Nav.Link>
  <Nav.Link as={Link} to="/primary-school/academic">ACADEMICS</Nav.Link>
  <Nav.Link as={Link} to="/primary-school/our-pillars">OUR PILLARS</Nav.Link>
  <Nav.Link as={Link} to="/primary-school/facilities">FACILITIES</Nav.Link>
  <Nav.Link as={Link} to="/primary-school/fees">FEES</Nav.Link>

</Nav>


          <Button onClick={handleContactClick} variant="outline-light" className="contact-button">
            SEND US A QUERY
          </Button>

          <div className="navbar-icons">
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Call: 083 569 0146</Tooltip>}>
              <i className="bi bi-telephone contact-icon"></i>
            </OverlayTrigger>

            <OverlayTrigger placement="bottom" overlay={<Tooltip>Email: highlandsc2015@gmail.com</Tooltip>}>
              <i className="bi bi-envelope-at contact-icon"></i>
            </OverlayTrigger>

            <OverlayTrigger placement="bottom" overlay={<Tooltip>WhatsApp: 082 567 0202</Tooltip>}>
              <i className="bi bi-whatsapp contact-icon"></i>
            </OverlayTrigger>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default PrimaryNav;
